export default function initShareButton() {
  const overlay = document.getElementById('share-overlay');
  if (!overlay) return;

  overlay.addEventListener('click', (e) => {
    const selection = window.getSelection();
    if (selection && selection.toString().length > 0) {
      return;
    }

    if (e.target.closest('.ShareClose')) {
      hideModal(overlay);
      return;
    }

    if (e.target.closest('.ShareModal')) {
      return;
    }

    if (e.target === overlay) {
      hideModal(overlay);
    }
  });

  document.addEventListener('click', (e) => {
    const shareBtn = e.target.closest('.Share__btn');
    if (!shareBtn) return;

    e.preventDefault();

    const shareUrl = shareBtn.dataset.shareUrl || shareBtn.getAttribute('href');
    if (!shareUrl) return;

    openModal(overlay, shareUrl);
  });
}

function openModal(overlay, shareUrl) {
  const shareUrlInput = overlay.querySelector('#share-url');
  shareUrlInput.value = shareUrl;

  if (!shareUrlInput.dataset.clickListenerAdded) {
    shareUrlInput.addEventListener('click', () => {
      shareUrlInput.select();
    });
    shareUrlInput.dataset.clickListenerAdded = 'true';
  }

  if (!shareUrlInput.dataset.focusListenerAdded) {
    shareUrlInput.addEventListener('focus', () => {
      shareUrlInput.select();
      copyToClipboard(shareUrlInput.value, overlay.querySelector('#share-copy'));
    });
    shareUrlInput.dataset.focusListenerAdded = 'true';
  }

  const copyBtn = overlay.querySelector('#share-copy');
  copyBtn.onclick = () => copyToClipboard(shareUrl, copyBtn);

  const shareMap = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
      shareUrl,
    )}&description=${encodeURIComponent('Check out my bag on Windsor!')}`,
    x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
  };
  Object.keys(shareMap).forEach((network) => {
    const btn = overlay.querySelector(`[data-share="${network}"]`);
    if (btn) {
      btn.onclick = () => window.open(shareMap[network], '_blank', 'noopener');
    }
  });

  document.querySelectorAll('[data-state]').forEach((el) => el.classList.add('State--modal-open'));
  overlay.classList.add('Modal--open');
  overlay.removeAttribute('aria-hidden');
  document.documentElement.classList.add('share-modal-open');
}

function hideModal(overlay) {
  const isMobile = window.innerWidth <= 767;

  if (isMobile) {
    overlay.classList.add('ShareOverlay--closing');
    overlay.classList.remove('Modal--open');

    const shareModal = overlay.querySelector('.ShareModal');
    const handleTransitionEnd = (e) => {
      if (e.propertyName === 'transform') {
        shareModal.removeEventListener('transitionend', handleTransitionEnd);

        overlay.classList.remove('ShareOverlay--closing');
        overlay.setAttribute('aria-hidden', 'true');
        document.querySelectorAll('[data-state]').forEach((el) => el.classList.remove('State--modal-open'));
        document.documentElement.classList.remove('share-modal-open');
      }
    };

    shareModal.addEventListener('transitionend', handleTransitionEnd);
  } else {
    overlay.classList.remove('Modal--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-state]').forEach((el) => el.classList.remove('State--modal-open'));
    document.documentElement.classList.remove('share-modal-open');
  }
}

let copyTimeoutId = null;

function copyToClipboard(text, btn) {
  navigator.clipboard.writeText(text).then(() => {
    if (copyTimeoutId) {
      clearTimeout(copyTimeoutId);
    }

    const original = btn.textContent !== 'Copied!' ? btn.textContent : 'Copy URL';
    btn.textContent = 'Copied!';

    copyTimeoutId = setTimeout(() => {
      btn.textContent = original;
      copyTimeoutId = null;
    }, 2000);
  });
}
